(function () {
  class Jq23pModeSwitch extends HTMLElement {
    connectedCallback() {
      if (this.inited) return;
      this.inited = true;
      this.init();
    }
 
    disconnectedCallback() {
      this.destroy();
      this.inited = false;
    }

    init() {
      this.tabs = Array.from(this.querySelectorAll("[data-msw-tab]"));
      this.media_panels = Array.from(this.querySelectorAll("[data-msw-media]"));
      this.copy_panels = Array.from(this.querySelectorAll("[data-msw-copy]"));
      const section_el = this.closest(".jq23p-msw");
      this.bg_panels = section_el
        ? Array.from(section_el.querySelectorAll("[data-msw-bg]"))
        : [];
      if (this.tabs.length === 0) return;

      this.active_index = this.tabs.findIndex((tab) => tab.classList.contains("is-active"));
      if (this.active_index < 0) this.active_index = 0;

      this.on_click = (event) => {
        const tab = event.target.closest("[data-msw-tab]");
        if (!tab || !this.contains(tab)) return;
        const index = Number(tab.getAttribute("data-msw-tab"));
        if (!Number.isFinite(index)) return;
        this.activate(index);
      };

      this.on_keydown = (event) => {
        const tab = event.target.closest("[data-msw-tab]");
        if (!tab || !this.contains(tab)) return;

        const last = this.tabs.length - 1;
        let next = this.active_index;

        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          next = this.active_index === last ? 0 : this.active_index + 1;
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          next = this.active_index === 0 ? last : this.active_index - 1;
        } else if (event.key === "Home") {
          next = 0;
        } else if (event.key === "End") {
          next = last;
        } else {
          return;
        }

        event.preventDefault();
        this.activate(next, true);
      };

      this.addEventListener("click", this.on_click);
      this.addEventListener("keydown", this.on_keydown);
      this.activate(this.active_index);
    }

    activate(index, focus_tab) {
      if (!Number.isFinite(index) || index < 0 || index >= this.tabs.length) return;
      this.active_index = index;

      this.tabs.forEach((tab, i) => {
        const is_active = i === index;
        tab.classList.toggle("is-active", is_active);
        tab.setAttribute("aria-selected", is_active ? "true" : "false");
        tab.setAttribute("tabindex", is_active ? "0" : "-1");
        if (is_active && focus_tab) tab.focus();
      });

      this.media_panels.forEach((panel, i) => {
        const is_active = i === index;
        panel.classList.toggle("is-active", is_active);
        panel.setAttribute("aria-hidden", is_active ? "false" : "true");
      });

      this.copy_panels.forEach((panel, i) => {
        const is_active = i === index;
        panel.classList.toggle("is-active", is_active);
        panel.setAttribute("aria-hidden", is_active ? "false" : "true");
      });

      (this.bg_panels || []).forEach((panel, i) => {
        panel.classList.toggle("is-active", i === index);
      });
    }

    destroy() {
      if (this.on_click) {
        this.removeEventListener("click", this.on_click);
        this.on_click = null;
      }
      if (this.on_keydown) {
        this.removeEventListener("keydown", this.on_keydown);
        this.on_keydown = null;
      }
    }
  }

  function mount_jq23p_mode_switch(root) {
    if (!root) return;
    const panels = root.matches("jq23p-mode-switch")
      ? [root]
      : Array.from(root.querySelectorAll("jq23p-mode-switch"));

    panels.forEach((panel) => {
      if (panel.inited) {
        panel.disconnectedCallback();
        panel.connectedCallback();
      }
    });
  }

  if (!customElements.get("jq23p-mode-switch")) {
    customElements.define("jq23p-mode-switch", Jq23pModeSwitch);
  }

  document.addEventListener("shopify:section:load", (event) => {
    mount_jq23p_mode_switch(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const panel = event.target.closest("jq23p-mode-switch");
    if (!panel || typeof panel.activate !== "function") return;

    const tab = event.target.closest("[data-msw-tab]");
    const media = event.target.closest("[data-msw-media]");
    const copy = event.target.closest("[data-msw-copy]");
    const bg = event.target.closest("[data-msw-bg]");
    let index = -1;

    if (tab) {
      index = Number(tab.getAttribute("data-msw-tab"));
    } else if (media) {
      index = Number(media.getAttribute("data-msw-media"));
    } else if (copy) {
      index = Number(copy.getAttribute("data-msw-copy"));
    } else if (bg) {
      index = Number(bg.getAttribute("data-msw-bg"));
    }

    if (index >= 0) panel.activate(index);
  });
})();
